import { AfterViewInit, Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { faArrowsRotate } from '@fortawesome/pro-duotone-svg-icons';

import { BehaviorSubject, map, Observable, switchMap } from 'rxjs';

import { MediaService } from '@eiq/files';
import { Question, heatmap } from '@empathy/survey-core';

@Component({
  selector: 'empathy-heatmap-question-view',
  templateUrl: 'heatmap-question-view.component.html',
  styleUrls: ['./heatmap-question-view.component.scss']
})
export class HeatmapQuestionViewComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() question: Question;
  @Input() questionCtrl: FormControl;

  mediaUrl$: Observable<SafeStyle>;

  faArrowsRotate = faArrowsRotate;
  heatmap: any = null;

  private mediaEvent$ = new BehaviorSubject<void>(null);
  private mediaService = inject(MediaService);
  private sanitizer = inject(DomSanitizer);

  private get canContinue(): boolean {
    return this.question.maxLength === 0 || this.heatmap.getData().data.length < this.question.maxLength;
  }

  ngOnInit(): void {
    this.mediaUrl$ = this.mediaEvent$.pipe(
      switchMap(() =>
        this.mediaService.getMediaUrl(this.question.imageHeatmap.mediaId).pipe(map((media) => this.sanitizer.bypassSecurityTrustStyle(`url('${media.url}')`)))
      )
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.question) {
      this.mediaEvent$.next();
    }
  }

  ngAfterViewInit(): void {
    const heatmapConfig = {
      container: document.querySelector('#heatmapContainer'),
      opacity: 0.6,
      radius: 20,
      visible: true,
      blur: 0.75,
      gradient: {
        '.5': '#eff6fc',
        '.8': '#8baee9',
        '.95': '#175cd3'
      },
      backgroundColor: 'inherit'
    };

    this.heatmap = heatmap.create(heatmapConfig);

    this.heatmap.setData({ data: [] });
    if (this.questionCtrl.value && this.questionCtrl.value.length > 0) {
      this.heatmap.addData(JSON.parse(this.questionCtrl.value));
    }

    document.getElementById('heatmapContainer').addEventListener('click', (evt) => this.mouseClick(evt));
  }

  onClear(): void {
    this.heatmap.setData({ data: [] });
    this.questionCtrl.reset();
  }

  private mouseClick(ev: any): void {
    if (!this.canContinue) {
      return;
    }

    const target = ev.target;
    const rect = target.getBoundingClientRect();
    const x = ev.clientX - rect.left;
    const y = ev.clientY - rect.top;
    const coordinates = { x, y, value: 1 };

    this.heatmap.addData(coordinates);
    this.questionCtrl.setValue(JSON.stringify(this.heatmap.getData().data));
  }
}
